<template>
  <turing-tabs :data="tabsData">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="能力演示" name="first">
        <test />
      </el-tab-pane>
    </el-tabs>
  </turing-tabs>
</template>
<script>
import test from '../pages/test/index'
export default {
  name: 'Home',
  components: {
    test,
  },
  data() {
    return {
      dialogOption: {
        show: false,
        component: undefined,
        title: '提示',
      },
      tabsData: {
        titleParam: {
          isShow: true,
          title: '通用图文识别',
          subtitle:
            '针对多场景、多语言的文字识别的市场需求，开发的识别引擎，支持拍照、印刷等多种应用场景，支持自然场景、文档、表格等多种版式，支持多种语言的文字识别。',
        },
      },
      activeName: 'first',
    }
  },
  // created() {
  //   //    console.log(this.$route.query.head)
  //   this.tabsData.titleParam.isShow = this.$route.query.head != "false";
  //   axios
  //     .get("/turing/v2/demo/uocr/info")
  //     .then(response => {
  //       console.log(response);
  //       this.tabsData.titleParam.title = response.data.title;
  //       this.tabsData.titleParam.subtitle = response.data.desc;
  //     })
  //     .catch(err => {
  //       console.log(err);
  //     });
  // },
  methods: {
    handleClick() {},
  },
}
</script>
<style>
.el-container {
  height: 100%;
}
.el-header {
  background-color: black;
  height: 60px;
}
.el-aside {
  width: auto;
}

.el-main {
  background-color: #ffffff;
  color: #333;
  text-align: center;
  line-height: 100%;
  padding: 15px;
}
</style>
